export class LocalisationService {
    constructor(languageName, textMap) {
        this._languages = {[languageName]: textMap};
        this._defaultLocale = languageName;
        this._currentLanguage = this._defaultLocale;
    }

    getLocales(){
        return [this._currentLanguage, this._defaultLocale];
    }

    setLanguage(languageName){
        this._currentLanguage = languageName;
    }

    addLanguage(languageName, textMap) {
        this._languages[languageName] = textMap;
    }

    getCurrentLanguage() {
        return this._currentLanguage;
    }

    _hasKeyInCurrentLanguage(key) {
        const hasLanguage = this._currentLanguage in this._languages;
        console.assert(hasLanguage, "ERROR: Missing language " + this._currentLanguage);

        if(!hasLanguage) return false;

        const languageHasKey = key in this._languages[this._currentLanguage];

        return languageHasKey;
    }

    getString(key, substitutions){

        if(!this._hasKeyInCurrentLanguage(key)){
            console.assert("ERROR: Missing text for " + key + " in " + this._currentLanguage);
            return "";
        }

        const localisedText = this._languages[this._currentLanguage];
        
        let string = localisedText[key];

        for(const key in substitutions){
            string = string.replace(`{${key}}`, substitutions[key]);
        }

        return string;
    }

    getStringOrNull(key, substitutions) {
        if(!this._hasKeyInCurrentLanguage(key)) return null;
        try {
            return this.getString(key, substitutions)
        } catch (_) {
            return null
        }
    }

    splitLinkText(key){
        const empty = {prefix: "", suffix: ""};

        if(!this._hasKeyInCurrentLanguage(key)) return empty;

        const parts = this._languages[this._currentLanguage][key].split("{LINK}");

        if(parts.length < 2) return empty;

        return {
            prefix: parts[0],
            suffix: parts[1]
        };
    }
}